import { getApplicationResourceManager } from '@neos/app'
import { createEnumType } from '@neos/core'

/**
 * Specifies the CustomViewStyleRuleContentDisplayMode.
 */
export enum CustomViewStyleRuleContentDisplayMode {
  /** Icon before text */
  iconBeforeText = 'IconBeforeText',
  /** Icon after text */
  iconAfterText = 'IconAfterText',
  /** Icon */
  icon = 'Icon'
}

export const customViewStyleRuleContentDisplayModeEnumType = createEnumType('CustomViewStyleRuleContentDisplayMode', {
  iconBeforeText: { name: 'IconBeforeText', get caption() { return getApplicationResourceManager('TaskScheduler').find('enums.CustomViewStyleRuleContentDisplayMode.IconBeforeText') ?? this.name }, getEnabled() { return true } },
  iconAfterText: { name: 'IconAfterText', get caption() { return getApplicationResourceManager('TaskScheduler').find('enums.CustomViewStyleRuleContentDisplayMode.IconAfterText') ?? this.name }, getEnabled() { return true } },
  icon: { name: 'Icon', get caption() { return getApplicationResourceManager('TaskScheduler').find('enums.CustomViewStyleRuleContentDisplayMode.Icon') ?? this.name }, getEnabled() { return true } },
})
